<div class="modal-header">
  <h4 class="modal-title">{{title}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" style="padding: 20px;">
    <div class="row" [ngClass]="messageClass" >
      <div class="col" style="overflow-wrap: anywhere;">
        <ng-template [ngIf]="message"><label>{{message}}</label></ng-template>
        <div [innerHtml]="messageHtml"></div>
      </div>
    </div>

   <ng-template [ngIf]="helpAvailable"><div class="row">
     <div class="col">

       <onlineHelp [session]="session"
                   [urlToHelpFr]='urlHelpFr'
                   [urlToHelpOther]='urlHelpOther'
                   [label] = "urlLabel" >
       </onlineHelp>

     </div>
   </div></ng-template>


    <ng-template [ngIf]="stackString"><div class="row" style="font-size: smaller !important;">
      <ng-template [ngIf]="stackStringVisible"><a class="naked" (click)="stackStringVisible = !stackStringVisible">
       <i class="fad fa-caret-square-down" style="--fa-primary-color: #374981; --fa-secondary-color: #374981;"></i> {{'StackTrace' | translate}}
      </a></ng-template>
      <ng-template [ngIf]="!stackStringVisible"><a class="naked" (click)="stackStringVisible = !stackStringVisible">
        <i class="fad fa-caret-square-right" style="--fa-primary-color: #374981; --fa-secondary-color: #374981;"></i> {{'StackTrace' | translate}}
      </a></ng-template>
      <ng-template [ngIf]="stackStringVisible"><div class="col">
        {{stackString}}
      </div></ng-template>
    </div></ng-template>



</div>


<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="onClose()">{{'Close' | translate}}</button>
</div>

